<template>
    <div class="incomeAll">
        <h6>修改密码</h6>

        <section class="safety">
            <form action="">
                <ul>
                    <li class="flex zhong">
                        <label>原密码：</label>
						<div class="sys-right">
							<input :type="isSee ? 'passWord' : 'text'" v-model="model.OldPassword" placeholder="请输入原密码" />
							<img style="cursor: pointer;" :src="isSee ? require('../../image/home_d.png') : require('../../image/home_dd.png')" @click="seeClick()" />
						</div>
                        <label
                            style="color:#333 ;margin-left: 1em;cursor: pointer;"
                            @click="password()"
                        >忘记密码?</label>
                    </li>
                    <li class="flex zhong">
                        <label>新密码：</label>
						<div class="sys-right">
							<input :type="isSeeNew ? 'passWord' : 'text'" v-model="model.NewPassword" placeholder="请输入新密码" />
							<img style="cursor: pointer;" :src="isSeeNew ? require('../../image/home_d.png') : require('../../image/home_dd.png')" @click="seeNewClick()" />
						</div>
                        <p>新密码长度为6~20个字符</p>
                    </li>
                    <li class="flex zhong">
                        <label>确认密码：</label>
						<div class="sys-right">
							<input :type="isSeeAfm ? 'passWord' : 'text'" v-model="newPasswordConfirm" placeholder="请再次输入新密码" />
							<img style="cursor: pointer;" :src="isSeeAfm ? require('../../image/home_d.png') : require('../../image/home_dd.png')" @click="seeAfmClick()" />
						</div>
                    </li>
                </ul>
                <button
                    type="button"
                    @click="save"
                >保存</button>
            </form>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            model: {
                OldPassword: '',
                NewPassword: ''
            },
            newPasswordConfirm: '',
			isSee: true,
			isSeeNew: true,
			isSeeAfm: true
        };
    },
    methods: {
		// 显示或隐藏密码
		seeClick() {
			this.isSee = !this.isSee;
		},
		seeNewClick() {
			this.isSeeNew = !this.isSeeNew;
		},
		seeAfmClick() {
			this.isSeeAfm = !this.isSeeAfm;
		},
        password() {
            this.$router.push('/passWord');
        },
        // 保存
        save() {
            if (!this.model.OldPassword) {
                this.$util.showError('请输入原密码');
                return;
            }
            if (!this.model.NewPassword) {
                this.$util.showError('请输入新密码');
                return;
            }
            if (!this.newPasswordConfirm) {
                this.$util.showError('请再次输入新密码');
                return;
            }
            if (this.model.NewPassword.length > 20 || this.model.NewPassword.length < 6) {
                this.$util.showError('密码长度应为6-20位');
                return;
            }
            this.$api.changePassword(this.model).then(res => {
                this.$store.dispatch('user/logout');
                this.$util.showOk(res.msg);
                setTimeout(() => {
                    this.$router.push('/login');
                }, 1000);
            });
        }
    }
};
</script>

<style scoped>
.safety button {
    font-size: 14px;
    border-radius: 4px;
    background-color: #333;
    height: 40px;
    line-height: 40px;
    display: block;
    margin: 60px auto 0 auto;
    color: #fff;
    text-align: center;
    width: 130px;
    cursor: pointer;
}

.safety input::-webkit-input-placeholder {
    color: #999;
}
.safety input:-moz-placeholder {
    color: #999;
}
.safety input:-ms-input-placeholder {
    color: #999;
}

.safety li p {
    font-size: 14px;
    color: #999;
    margin-left: 34px;
}

.safety li > input {
    width: 300px;
    font-size: 14px;
    color: #333;
    height: 40px;
    background-color: #fff;
    border: solid 1px #e6e6e6;
    border-radius: 4px;
    line-height: 40px;
    text-indent: 1em;
    margin-left: 20px;
}

.safety li label {
    font-size: 14px;
    width: 80px;
    text-align: right;
    display: inline-block;
}
.sys-right{
	width: 300px;
	margin-left: 20px;
	display: flex;
	align-items: center;
	height: 40px;
	background-color: #fff;
	border: solid 1px #e6e6e6;
	border-radius: 4px;
	line-height: 40px;
	padding-right: 15px;
}
.sys-right input {
	background-color: #fff;
    width: 300px;
    font-size: 14px;
    color: #333;
    margin-left: 20px;
}

.sys-right > img {
	width: 20px;
	height: 20px;
	display: block;
}
.safety li {
    margin-bottom: 15px;
}

.safety ul {
    background-color: #eaeaea;
    overflow: hidden;
    padding: 30px 0 30px 88px;
}

.safety {
    margin: 30px 20px;
    overflow: hidden;
}

/* safety */

.incomeAll > h6 {
    border-bottom: solid 1px #e6e6e6;
    font-size: 16px;
    color: #333;
    height: 62px;
    line-height: 62px;
    text-indent: 20px;
    position: relative;
}

.incomeAll > h6::after {
    content: '';
    width: 70px;
    height: 2px;
    background-color: #333;
    position: absolute;
    left: 20px;
    bottom: 0;
    z-index: 0;
}
</style>
